<template>
    <div id="recordBox">
        <el-dialog title="记录添加" :visible.sync="dialogAdd.show" @close="closeDialog()" width="35%" :modal-append-to-body='false'>
            <div class="for-groups">
                <div class="form-group">
				<label>巡查日期</label>
                    <el-date-picker
                        v-model="searchtime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        align="right"
                        :editable="false">
                    </el-date-picker>
			    </div>
                <div class="form-group">
                    <label>部位</label>
                    <el-select v-model="place" class="select">
                        <el-option v-for="item in places" :key="item.place" :label="item.label" :value="item.place"></el-option>
                    </el-select>
                </div>
                <div class="form-group">
                    <label>病害类型</label>
                    <el-select v-model="reason" class="select">
                        <el-option v-for="item in types" :key="item.reason" :label="item.label" :value="item.reason"></el-option>
                    </el-select>
                </div>
            </div>
			<div style="width:100%;margin-top:10px">
                <textarea v-model="descr" class="form_control"  rows="3" placeholder="描述"></textarea>
            </div>
            <div class="pics">
                <el-upload
                    :before-upload="beforeAvatarUpload"
                    list-type="picture"
                    :on-preview="handlePictureCardPreview"
                    :limit="3"
                    :multiple="true"
                    accept=".jpg, .png"
                    action="/api/monitor/fileUpload/uploadImage"
                    :data="uploadData"
                    :on-exceed="handleExceed"
                    :on-success="handleAvatarSuccess"
                    :on-remove="handleRemove">
                    <el-button size="small" type="primary">上传图片</el-button>
                    <!-- <div class="pic"> <img src="../../assets/image/add_bg.png" ></div> -->
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAdd.show = false">关 闭</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        name: 'AddRecord',
        props:{
            dialogAdd:Object
        },
        data () {
            return {
                imageUrl: '',
                uploadData: { //上传文件时要上传的额外参数
                    // userId: 'U0001',
                    // userName: 'admin'
                },
                searchtime:'',
                place:'',
                reason:'',
                descr:'',
                places:[{
                    place:'顶部土体',
                    label:'顶部土体'
                },{
                    place:'坑底',
                    label:'坑底'
                },{
                    place:'冠梁',
                    label:'冠梁'
                },{
                    place:'围檩',
                    label:'围檩'
                },{
                    place:'挡墙',
                    label:'挡墙'
                },{
                    place:'止水帷幕',
                    label:'止水帷幕'
                },{
                    place:'周围建(构)物',
                    label:'周围建(构)物'
                },{
                    place:'其他',
                    label:'其他'
                }],
                types:[{
                    reason:'裂缝',
                    label:'裂缝'
                },{
                    reason:'位移',
                    label:'位移'
                },{
                    reason:'倾斜',
                    label:'倾斜'
                },{
                    reason:'破损',
                    label:'破损'
                },{
                    reason:'沉降',
                    label:'沉降'
                },{
                    reason:'隆起',
                    label:'隆起'
                },{
                    reason:'渗漏水',
                    label:'渗漏水'
                },{
                    reason:'变形',
                    label:'变形'
                },{
                    reason:'其他',
                    label:'其他'
                }],
                image_str:[],
                dialogImageUrl: '',
                dialogVisible: false
            }
        },
        methods:{
            handleAvatarSuccess(res, file){
                this.image_str.push(res.datas.values)
            },
            beforeAvatarUpload(file) {
                /* const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if(!isJPG){
                this.$message.error('上传图片只能是jpg格式！');
                }
                if(!isLt2M){
                this.$message.error('上传图片不能超过2M');
                }
                return isJPG && isLt2M; */
            },
            closeDialog(){
                this.dialogAdd.show = false;
                /* 清除表单 */
                this.searchtime = ''
                this.place = '';
                this.reason = '';
                this.descr = '';
                this.image_str = []
            },
            addDocFile(file) {
                this.src = file.url;
            },
            handleExceed(files) {
                this.$message.warning(`最多只能上传三张图片!`);
            },
            handlePictureCardPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                // 删除功能，拼接的字符串中如果包含url,直接去掉此url
                if(this.image_str.indexOf(file.response)){
                    this.image_str = this.image_str.splice(this.image_str.indexOf(file.response),1);
                }
            },
            submitForm(ruleForm) {
                const req = {
                    searchTime:this.searchtime,
                    position:this.place,
                    reason:this.reason,
                    described:this.descr,
                    imageUrl:JSON.stringify(this.image_str),
                }
                if(!this.searchtime || !this.place || !this.reason ){
                    this.$message({
                        type:"warning",
                        message:"请选择巡查日期、部位、病害类型",
                    });
                    return
                }
                console.log(req,544)
                // return;
                // this.$axios.post('/api/monitor/SearchRecords/addSearchRecords',req).then(res => {
                this.$axios.post('/api/monitor/SearchRecords/addSearchRecordsNew',req).then(res => {
                    if(res.data.status == 200){
                        this.$message({
                            type:"success",
                            message:"巡查记录添加成功",
                        });
                        this.dialogAdd.show = false;
                        this.$emit('update');
                        /* 清除表单 */
                        this.searchtime = ''
                        this.place = '';
                        this.reason = '';
                        this.descr = '';
                        this.image_str = []
                    }else{
                        return false
                    }
                })
            }
        }
    }
</script>

<style>

  #recordBox .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  #recordBox .el-dialog__body {
    padding: 10px 20px;
  }

  #recordBox .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }

    #recordBox .el-select{
        width: 100px;
    }

    /* #recordBox .el-upload-list__item{
        width: 31% !important;
        float: left;
    } */

</style>

<style scoped>

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px !important;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .form-group {
        margin-bottom: 15px;
        display: inline-block;
    }

    label {
        display: inline-block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    .form_control{
        width: 95%
    }

    .pics{
        /* height: 175px; */
        /* width: 568px; */
        width: 100%;
    }

    .pic{
        height: 170px;
        float: left;
        margin-left: 20px;
        position: relative;
    }

    .pic img{
        display: inline-block;
        margin: auto;
        max-height: 168px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/dataManage/AddRecord.vue